// extracted by mini-css-extract-plugin
export default {"split_vertical_panels":"SplitVerticalPanels_split_vertical_panels__-Dj5F","split_vertical_panels__pane":"SplitVerticalPanels_split_vertical_panels__pane__8sCQ4"};